import { Grid, Typography } from '@material-ui/core';
import { graphql } from 'gatsby';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Helmet from 'react-helmet';
import Intro from '../components/Intro/IntroSubPages';
import ProductComponent from '../components/Products/Product';
import theme from '../theme';
import Container from '../components/Container';

export const query = graphql`
  query Category {
    strapiProduct: allStrapiProduct(filter: {status: {eq: "published"}}) {
      edges {
        node {
          slug
          title
          description
          price
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 150)
              }
            }
          }
        }
      }
    }
  }
`;

const useStyles = makeStyles({
  wrapper: {
    overflow: 'hidden',
    backgroundColor: '#F9F9F9',
    padding: '5rem',
  },
  intro: {
    height: '25vh',
    maxHeight: 250,
    position: 'relative',
    overflow: 'hidden',
    '& .background-image-wrapper': {
        maxHeight: '100%',
        '& .background-image': {
          width: '100%',
          maxHeight: '100%',
      },
    },
  },
  product: {
    // padding: '1rem',
  },
  title: {
    color: '#000000DE',
    fontWeight: 'bold',
    marginBottom: '5rem',
  },
  highlighted: {
    backgroundColor: '#5841D8',
    color: '#fff',
    padding: theme.spacing(2),
},
});

const Products = ({ data }) => {
  const classes = useStyles();
  const products = data.strapiProduct.edges;
  return (
    <ThemeProvider theme={theme}>
      <SEO title="Meetrix.IO | Products" description={'Meetrix Products'} />
      <Helmet>
      {/* Global site tag (gtag.js) - Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-118777783-1"></script>
      <script type="text/javascript">
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'UA-118777783-1');`}
      </script>
      </Helmet>
      <Layout pageName={'Products'}>
      {/* <Intro headingCenter="Meetrix Marketplace" customStyles={classes.intro}/> */}
      <div className={classes.highlighted}>
        <Container>Save over 90% of cost compared to manual deployment</Container>
      </div>
        <div className={classes.wrapper} >
        <Typography variant="h4" className={classes.title}>
          Launch and manage your Jitsi infrastructure as code
        </Typography>
          <Grid container spacing={3}>
            {products.map(({ node }) => {
              const { title, description, price, image, slug } = node;
              return (
                <Grid item xs={12} sm={4} lg={3} className={classes.product}>
                  <ProductComponent title={title} description={description} price={price} gatsbyImageData={image.localFile.childImageSharp.gatsbyImageData} slug={slug} />
                </Grid>
              );
            })}
          </Grid>
        </div>
      </Layout>
    </ThemeProvider>
  );
};

export default Products;
